import React, { useEffect } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowLeft,
  faCheck as fasCheck,
  faCircleCheck as fasCircleCheck,
  faSquare,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import {
  faCheck,
  faCircleQuestion,
  faInfoCircle,
} from '@fortawesome/pro-light-svg-icons';
import {
  faArrowRight,
  faCircleCheck,
  faCircleXmark,
  faHandWave,
  faHeartCrack,
  faInbox,
  faCheck as falCheck,
  faLockAlt,
  faQuestionCircle,
  faCircle as farCircle,
  faRepeat,
  faSpinnerThird,
  faThumbsUp,
  faTriangleExclamation,
} from '@fortawesome/pro-regular-svg-icons';
import { ErrorBoundary, Provider } from '@rollbar/react';
import { Toaster } from 'react-hot-toast';
import { Route, Switch } from 'react-router-dom';

import { rollbarConfig } from './actions/general';
import ErrorPage from './components/ErrorPage';
import Index from './components/Index';
import Invalid from './components/Invalid';
import Session from './components/Session';
import Apply from './components/sessions/Apply';
import Finish from './components/sessions/Finish';
import Init from './components/sessions/Init';
import PostApproval from './components/sessions/PostApproval';
import Purchase from './components/sessions/Purchase';
import Reapply from './components/sessions/Reapply';
import { ProvideAuth } from './hooks/useAuth';
import useOscilar from './hooks/useOscilar';

// Add icons to FA library for global usage
library.add(
  faCircleQuestion,
  faCircleCheck,
  faInfoCircle,
  faQuestionCircle,
  faTimes,
  faLockAlt,
  faThumbsUp,
  faRepeat,
  faCircleXmark,
  faArrowLeft,
  faTriangleExclamation,
  faSquare,
  faHandWave,
  faInbox,
  faHeartCrack,
  fasCircleCheck,
  faSpinnerThird,
  faArrowRight,
  faCheck,
  fasCheck,
  falCheck,
  farCircle
);

export const fromLearnMore = new URLSearchParams(window.location.search).get(
  'learn-more'
);

export const workflows = [
  {
    path: '/init',
    component: Init,
  },
  {
    path: '/reapply',
    component: Reapply,
  },
  {
    path: '/apply',
    component: Apply,
  },
  {
    path: '/post_approval',
    component: PostApproval,
  },
  {
    path: '/purchase',
    component: Purchase,
  },
  {
    path: '/finish',
    component: Finish,
  },
  {
    path: '/invalid',
    component: Invalid,
  },
  {
    path: '/error',
    component: ErrorPage,
  },
];

export default function App() {
  // load the Oscilar snippet and update session with their returned IDs
  const { error } = useOscilar();

  useEffect(() => {
    if (error) console.error(error);
  }, [error]);

  return (
    <Provider config={rollbarConfig}>
      <ErrorBoundary>
        <ProvideAuth>
          <div className="App flex flex-col overflow-hidden text-primary">
            <main className="flex-grow overflow-auto">
              <Switch>
                <Route exact path="/" component={Index} />
                <Route
                  path={workflows.map((w) => w.path)}
                  component={Session}
                />
                <Route
                  path="/:public_key/:prequalification_id?"
                  component={Session}
                />
              </Switch>
            </main>
            <Toaster
              position="bottom-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                },
                success: {
                  duration: 3000,
                  iconTheme: {
                    primary: '#4ade80',
                    secondary: '#fff',
                  },
                },
                error: {
                  duration: 5000,
                  iconTheme: {
                    primary: '#ef4444',
                    secondary: '#fff',
                  },
                },
              }}
            />
          </div>
        </ProvideAuth>
      </ErrorBoundary>
      <div className="h-[600px] hidden"></div>
    </Provider>
  );
}
